<template>
  <div>
    Select a report to view:
    <ul>
      <li>
        >
        <router-link :to="{name:'sales-by-pack'}">Sales by Pack</router-link>
      </li>
    </ul>

    <div v-if="isSuperUser">
      <div v-if="loadComplete">
        <div class="chart-header">
          <select name="dataType" v-model="dataType" class="title is-3 select chart-select">
            <option value="order_comparison">Order Activity</option>
            <option value="revenue_comparison">Revenue</option>
            <option value="payment_comparison">Payment Type</option>
          </select>

          <div class="chart-options">
            <div class="date-range">
              Range
              <input type="text"
                     name="activity_start"
                     class="input date-input"
                     :value="activityStart"
                     id="activity_start">
              -
              <input type="text"
                     name="activity_end"
                     class="input date-input"
                     :value="activityEnd"
                     id="activity_end">
            </div>
          </div>
        </div>

        <div style="position: relative; user-select: none">
          <order-chart v-if="!reloadActivityChart"
                       :dataType="dataType"
                       :startDay="activityStart"
                       :endDay="activityEnd"></order-chart>
        </div>
      </div>
      <div v-else>
        loading...
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters}  from "vuex"
import moment        from "moment/moment.js"
import bulmaCalendar from "bulma-calendar/dist/bulma-calendar"

export default {
  name: 'all-reports',
  data() {
    return {
      activityStart: moment().startOf('day').subtract(7, 'days').format('Y-MM-DD'),
      activityEnd: moment().endOf('day').format('Y-MM-DD'),
      activityDays: 7,
      dataType: 'order_comparison',
      reloadTimeout: 0,
      reloadActivityChart: false,
      chartReloadTimer: 0,
      chartReloadTimeout: 50,
      startDatePicker: null,
      endDatePicker: null,
    }
  },
  mounted() {
    if (this.isSuperUser && this.loadComplete) {
      this.createStartDatePicker();
      this.createEndDatePicker();
    }
    else {
      this.load_check = setInterval(() => {
        if (this.isSuperUser && this.loadComplete) {
          this.createStartDatePicker();
          this.createEndDatePicker();
          clearInterval(this.load_check)
        }
      }, 500);
    }
  },
  methods: {
    createStartDatePicker() {
      if (this.startDatePicker !== null && this.startDatePicker.destroy) {
        this.startDatePicker.destroy()
        document.querySelector('#' + this.startDatePicker._id).remove()
      }
      this.startDatePicker = new bulmaCalendar(document.getElementById('activity_start'), {
        startDate: moment(this.activityStart).startOf('day').toDate(), // Date selected by default
        minDate: moment('2009-01-01').startOf('day').toDate(),
        maxDate: moment(this.activityEnd).subtract(1, 'days').endOf('day').toDate(),
        dateFormat: 'yyyy-mm-dd', // the date format `field` value
        lang: 'en', // internationalization
        overlay: true,
        closeOnOverlayClick: true,
        closeOnSelect: true,
        // callback functions
        onSelect: (date) => {
          this.activityStart = moment(date).format('Y-MM-DD')
          this.createEndDatePicker();
        },
        onOpen: null,
        onClose: this.reloadChart(),
        onRender: null
      });
    },
    createEndDatePicker() {
      if (this.endDatePicker !== null && this.endDatePicker.destroy) {
        this.endDatePicker.destroy()
        document.querySelector('#' + this.endDatePicker._id).remove()
      }
      this.endDatePicker = new bulmaCalendar(document.getElementById('activity_end'), {
        startDate: moment(this.activityEnd).endOf('day').toDate(), // Date selected by default
        minDate: moment(this.activityStart).add(1, 'days').endOf('day').toDate(),
        maxDate: moment().add(1, 'months').endOf('day').toDate(),
        dateFormat: 'yyyy-mm-dd', // the date format `field` value
        lang: 'en', // internationalization
        overlay: true,
        closeOnOverlayClick: true,
        closeOnSelect: true,
        // callback functions
        onSelect: (date) => {
          this.activityEnd = moment(date).format('Y-MM-DD')
          this.createStartDatePicker();
        },
        onOpen: null,
        onClose: this.reloadChart(),
        onRender: null
      });
    },
    refreshChart() {
      this.reloadChart()
    },
    reloadChart() {
      this.reloadActivityChart = true
      setTimeout(() => {
        this.reloadActivityChart = false;
      }, 200);
    },
  },
  computed: Object.assign({}, mapGetters([
    'reportCompany',
    'loadComplete',
    'apiBusy',
    'isSuperUser',
    'pages',
    'products',
    'bundles',
    'categories',
    'items',
    'tags',
    'images',
    'newOrders',
    'orders',
    'ordersLastSync',
    'allNonVoidedOrders',
    'printedOrders',
    'archivedOrders',
    'voidedOrders',
    'newCatalogRequests',
    'subscriptions',
    'users',
  ]), {
    revenue() {
      let gross     = this.allNonVoidedOrders.reduce((total, current, index, arr) => {
        return total + parseFloat(current.total);
      }, 0)
      let cardGross = this.allNonVoidedOrders.filter(order => order.payment_method !== 'Paypal')
                          .reduce((total, current, index, arr) => {
                            return total + parseFloat(current.total);
                          }, 0)

      let paypalOrders = this.allNonVoidedOrders.filter(order => order.payment_method === 'Paypal');
      let paypalGross  = 0;
      let paypalFees   = 0;
      for (let x = 0; x < paypalOrders.length; x++) {
        let orderTotal = parseFloat(paypalOrders[x].total);
        paypalGross += orderTotal
        paypalFees += ((orderTotal * 0.0325) + .25)
      }

      return {
        gross,
        net: gross - paypalFees,
        cardGross,
        paypalGross,
        paypalFees,
        paypalNet: paypalGross - paypalFees,
      }
    },
  }),
  watch: {
    dataType() {
      clearTimeout(this.chartReloadTimer)
      this.chartReloadTimer = setTimeout(() => {
        this.reloadChart()
      }, this.chartReloadTimeout);
    },
    '$store.state.company'() {
      clearTimeout(this.chartReloadTimer)
      this.chartReloadTimer = setTimeout(() => {
        this.reloadChart()
      }, this.chartReloadTimeout);
    }
  }
}
</script>



// WEBPACK FOOTER //
// Summary.vue?e829b762